import(/* webpackMode: "eager", webpackExports: ["AboutLodging"] */ "/app/app/[lang]/(public)/(home)/_components/AboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lang]/(public)/(lodgings)/lodgings/[slug]/_components/filters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Ad"] */ "/app/app/components/atoms/ad.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLinkButton"] */ "/app/app/components/atoms/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentLayout","OptionsLayout","AsideLayout"] */ "/app/app/components/molecules/layouts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NoResult"] */ "/app/app/components/molecules/noresult.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LodgingCard"] */ "/app/app/components/organisms/lodgings/lodging_card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "/app/node_modules/primereact/skeleton/skeleton.esm.js");
